import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getCodeSpecificationApi } from "../../end-points/codeSpecification";
import { toast } from "react-toastify";

const initialState = {
  showSpecification: false,
  showOverview: false,
  repoPath: "",
  /* source_language: "",
      target_language: "", */
  loading: false,
  specification: ""
}

export const getCodeSpecification = createAsyncThunk(
  "codeSpecification/getCodeSpecification", getCodeSpecificationApi
)

export const codeSpecificationSlice = createSlice({
  name: "codeSpecification",
  initialState,
  reducers: {
    setShowSpecification: (state, action) => {
      state.showSpecification = action.payload;
      if (action.payload === true) {
        state.showOverview = false;
      }
    },
    setShowOverview: (state, action) => {
      state.showOverview = action.payload;
      if (action.payload === true) {
        state.showSpecification = false;
      }
    },
    resetSpecification: (state) => {
      state.showSpecification = false
      state.showOverview = false
      state.specification = ""
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getCodeSpecification.pending, (state) => {
      console.log("Loading...", state);
      state.loading = true;
    })
    builder.addCase(getCodeSpecification.fulfilled, (state, action) => {
      console.log("Success...", state, action);
      state.specification = action.payload.specification;
      state.showSpecification = true;
      state.showOverview = false;
      state.loading = false;
      console.log("specification", state.specification);
    })
    builder.addCase(getCodeSpecification.rejected, (state, action) => {
      console.log("Error", state, action);
      toast.error(action.error.message)
      state.loading = false;
    })
  }

})

// Action creators are generated for each case reducer function
export const { setShowSpecification, setShowOverview, resetSpecification } = codeSpecificationSlice.actions;

export default codeSpecificationSlice.reducer